import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { FormService } from 'src/app/_core/services/form.service';
import { ECommerceCustomer } from 'src/app/_core/types/types';
import {
  email,
  phoneNumber,
  password,
  matchPassword,
} from 'src/app/_core/utils/helpers/validators';

export type RegisterForm = {
  firstName: FormControl<string>;
  lastName: FormControl<string>;
  email: FormControl<string>;
  phone: FormControl<string>;
  password?: FormControl<string>;
  repeatPassword?: FormControl<string>;
  statute: FormControl<boolean>;
};

@Injectable({ providedIn: 'root' })
export class RegisterFormService extends FormService<RegisterForm> {
  constructor() {
    super();

    this.form = this.fb.group<RegisterForm>(
      {
        firstName: this.fb.control('', [
          Validators.required,
          Validators.maxLength(100),
        ]),
        lastName: this.fb.control('', [
          Validators.required,
          Validators.maxLength(100),
        ]),
        email: this.fb.control('', [
          email,
          Validators.required,
          Validators.maxLength(100),
        ]),
        phone: this.fb.control('', [phoneNumber, Validators.required]),
        password: this.fb.control('', [
          password,
          Validators.required,
          Validators.minLength(8),
        ]),
        repeatPassword: this.fb.control('', [
          password,
          Validators.required,
          Validators.minLength(8),
        ]),
        statute: this.fb.control(false, [Validators.requiredTrue]),
      },
      { validators: [matchPassword('password', 'repeatPassword')] }
    );
  }

  patchFormValues(values: ECommerceCustomer): void {
    this.form.patchValue({
      firstName: values.firstName ?? '',
      lastName: values.lastName ?? '',
      email: values.email ?? '',
      phone: values.phoneNumber ?? '',
    });

    const { password, repeatPassword, statute } = this.form.controls;
    password?.clearValidators();
    repeatPassword?.clearValidators();
    statute.clearValidators();
  }
}
